import cn from 'classnames';

import LinkList from 'components/link-list/LinkList';
import Heading from 'components/heading/Heading';

import { ILinkListBlock } from 'source/NFR.types';

interface LinkListBlockProps extends ILinkListBlock {
  className?: string;
}

const LinkListBlock: React.FC<LinkListBlockProps> = ({ className, htmlId, links, title }) => (
  <div className={cn('link-list-block', className)}>
    {title && <Heading id={htmlId}>{title}</Heading>}
    <LinkList withIcon {...links} />
  </div>
);

LinkListBlock.displayName = 'LinkListBlock';

export default LinkListBlock;
